module.exports = __webpack_public_path__ + "img/Admin Home.8c8f4a1a.svg";